import { GetAccountTopAppsMetricsSummaryQuery } from '../../../../src/interface/queries/top-apps/get-account-top-apps-metrics-summary.query';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountTopAppsMetricsSummaryRequestDto } from '../../../../src/interface/dtos/top-apps/get-account-top-apps-metrics-summary.request.dto';
import { GetAccountTopAppsMetricsSummaryResponseDto } from '../../../../src/interface/dtos/top-apps/get-account-top-apps-metrics-summary.response.dto';
import { AccountTopAppsMetricsSummaryAggregateRootMapper } from '../../../../src/infrastructure/mappers/top-apps/account-top-apps-metrics-summary.aggregate-root.mapper';

export class GetAccountTopAppsMetricsSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountTopAppsMetricsSummaryQuery,
    protected readonly mapper: AccountTopAppsMetricsSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountTopAppsMetricsSummaryRequestDto
  ): Promise<GetAccountTopAppsMetricsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);

      const offset = props.params.offset || 0;
      const limit = props.params.limit || 100;

      const formattedResult = result
        .map((r) => this.mapper.toResponse(r))
        .sort((a, b) => Number(b.totalViews) - Number(a.totalViews))
        .slice(offset, offset + limit);

      return {
        data: formattedResult,
        limit: props.params.limit,
        offset: props.params.offset,
      };
    } catch (error) {
      throw new Error(
        `GetAccountTopAppsMetricsSummaryController.get encountered an error ${error}`
      );
    }
  }
}
